import { Box } from '@/components/Box/Box';
import { ReactNode } from 'react';
import { TableNewFooter, TableNewWrapper } from './styles';
import { COLORS } from '@/styles/colors';
import { TableNewLoader } from './TableNewLoader/TableNewLoader';
import { Typography } from '@/components/Typography/Typography';

type TableNewType = {
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  noItems: ReactNode;
  itemsCount: number;
  isLoading: boolean;
};

export const TableNew = ({ header, footer, isLoading, noItems, itemsCount = 0, children }: TableNewType) => {
  const bodyStyles = header ? { padding: '12px 24px 24px' } : { padding: '24px' };

  return (
    <Box
      display='flex'
      flexDirection='column'
      border={`1px solid ${COLORS.grey[400]}`}
      borderRadius={'16px'}
      overflow='hidden'
      background={COLORS.white}
    >
      {header && <Box padding='24px 24px 0 24px'>{header}</Box>}
      {isLoading && <TableNewLoader />}

      {!isLoading && itemsCount === 0 && (
        <Box {...bodyStyles}>
          <Typography>{noItems}</Typography>
        </Box>
      )}

      {!isLoading && itemsCount > 0 && <TableNewWrapper>{children}</TableNewWrapper>}

      {footer && <TableNewFooter>{footer}</TableNewFooter>}
    </Box>
  );
};
